// extracted by mini-css-extract-plugin
export var csatScore = "_j6-5";
export var header = "_j6-1";
export var panelWrapper = "_j6-2";
export var postPreview = "_j6-3";
export var rightContent = "_j6-0";
export var wrappingText = "_j6-4";